import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import AutoComplete from 'material-ui/AutoComplete';
import IconButton from 'material-ui/IconButton';

import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import { getRequestsCargo } from 'actions/cargoes/requests';
import api from 'services';

import CargoRequestsItem from './Item';
import { EhSelector } from 'components/Base/EhSelector';
import { toUTC } from '../../../helpers/dates';

const styles = {
    radioGroup: {
        margin: '20px 0',
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '25%',
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: '.5em',
        fontSize: '.75em',
    },
    paginationSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paginationText: {
        margin: '0 1.25em',
    },
    paginationSelect: {
        width: 75,
        fontSize: '1em',
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer',
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)',
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer',
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)',
    },
};

function parseQueryString() {
    return document.location.search.substr(1).split('&').reduce((acc, p) => {
        const [_1, _2] = p.split('=').map(decodeURIComponent);
        acc[_1] = _2;
        return acc;
    }, {});
}

class CargoRequestsList extends React.Component {
    constructor(props) {
        super(props);

        const query = parseQueryString();

        this.state = {
            page: 1,
            search: query.q || '',

            volumeMax: '',
            volumeMin: '',

            weightMax: '',
            weightMin: '',

            cargoName: '',
            cargoId: '',
            cargoNames: [],

            cargoType: '',
            cargoTypeName: '',
            cargoTypeNames: [],

            listUnloadingPorts: [],
            unloadingPortName: '',
            unloadingPort: '',

            listLoadingPorts: [],
            loadingPortName: '',
            loadingPort: '',

            readinessDate: '',
            cancellingDate: '',

            eh: [],
        };

        this.updateRows = this.updateRows.bind(this);
        this.handleSearch = this.handleSearch.bind(this);

        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);

        this.onChooseAutoComplete = this.onChooseAutoComplete.bind(this);
        this.onChangeAutoComplete = this.onChangeAutoComplete.bind(this);

        this.onUpdateInputCargoType = this.onUpdateInputCargoType.bind(this);
        this.onNewRequestCargoTypes = this.onNewRequestCargoTypes.bind(this);

        this.onUpdateInputCargoName = this.onUpdateInputCargoName.bind(this);
        this.onNewRequestCargoName = this.onNewRequestCargoName.bind(this);

        this.changeDate = this.changeDate.bind(this);

        this.changeValues = this.changeValues.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleEhChange = this.handleEhChange.bind(this);
    }

    handleClearFilters() {
        this.setState({
            page: 1,
            search: '',

            volumeMax: '',
            volumeMin: '',

            weightMax: '',
            weightMin: '',

            cargoName: '',
            cargoId: '',
            cargoNames: [],

            cargoType: '',
            cargoTypeName: '',

            listUnloadingPorts: [],
            unloadingPortName: '',
            unloadingPort: '',

            listLoadingPorts: [],
            loadingPortName: '',
            loadingPort: '',

            readinessDate: '',
            cancellingDate: '',

            eh: [],
        }, () => {
            this.updateRows(this.state);
        });
    }

    changeValues(type, value) {
        const state = this.state;
        state[type] = value;
        this.setState(state);
    }

    changeDate(type, date) {
        if (type === 'readinessDate') {
            this.setState({
                readinessDate: moment(date),
            });
        } else {
            this.setState({
                cancellingDate: moment(date),
            });
        }

        console.log('type', type);
        console.log('date', date);
    }

    onUpdateInputCargoName(searchText) {
        this.setState({
            cargoName: searchText,
        }, () => {
            api.getCargoNamesAutocomplete(searchText)
                .then((response) => {
                    const cargoNames = response.data.data.map(realCargoName => ({
                        name: realCargoName.name,
                        item: realCargoName,
                    }));

                    this.setState({
                        cargoNames,
                    });
                })
                .catch(() => null);
        });
    }

    onNewRequestCargoName(updateProperties) {
        if (!updateProperties) {
            return;
        }

        this.setState({
            cargoName: updateProperties.name,
            cargoId: updateProperties.item._id,
        });
    }

    onUpdateInputCargoType(searchText) {
        this.setState({
            cargoTypeName: searchText,
        });
    }

    onNewRequestCargoTypes(updateProperties) {
        if (!updateProperties.name) {
            return;
        }

        this.setState({
            cargoTypeName: updateProperties.name,
            cargoType: updateProperties.item._id,
        });
    }

    onChangeAutoComplete(searchText, type) {
        if (type === 'loading') {
            this.setState({
                loadingPortName: searchText,
                loadingPort: '',
            });
        } else {
            this.setState({
                unloadingPortName: searchText,
                unloadingPort: '',
            });
        }

        if (searchText.length <= 2) {
            return;
        }

        api.findPortAdmin({ name: searchText, withAreas: true })
            .then((response) => {
                if (type === 'loading') {
                    const listLoadingPorts = [];
                    response.data.data.forEach((port) => {
                        if (port.sub) {
                            port.sub.forEach((subPort) => {
                                listLoadingPorts.push({
                                    name: `${subPort.name} - country ${port.country.name}`,
                                    item: subPort,
                                });
                            });
                        }

                        let name = '';
                        if (port.country) {
                            name = `${port.name} - country ${port.country.name}`;
                        } else {
                            name = port.name;
                        }

                        listLoadingPorts.push({
                            name,
                            item: port,
                        });
                    });

                    this.setState({
                        listLoadingPorts,
                    });
                } else {
                    const listUnloadingPorts = [];

                    response.data.data.forEach((port) => {
                        if (port.sub) {
                            port.sub.forEach((subPort) => {
                                listUnloadingPorts.push({
                                    name: `${subPort.name} - country ${port.country.name}`,
                                    item: subPort,
                                });
                            });
                        }

                        let name = '';
                        if (port.country) {
                            name = `${port.name} - country ${port.country.name}`;
                        } else {
                            name = port.name;
                        }

                        listUnloadingPorts.push({
                            name,
                            item: port,
                        });
                    });

                    this.setState({
                        listUnloadingPorts,
                    });
                }
            })
            .catch(() => null);
    }

    onChooseAutoComplete(type, updateProperties) {
        if (!updateProperties) {
            return;
        }

        if (type === 'loading') {
            this.setState({
                loadingPort: updateProperties.item._id,
                loadingPortName: updateProperties.name,
            });
        } else {
            this.setState({
                unloadingPort: updateProperties.item._id,
                unloadingPortName: updateProperties.name,
            });
        }
    }

    nextPage() {
        this.setState({
            page: this.props.cargoRequests.next,
        }, () => {
            this.updateRows(this.state);
        });
    }

    prevPage() {
        this.setState({
            page: this.props.cargoRequests.previous,
        }, () => {
            this.updateRows(this.state);
        });
    }

    updateRows(state) {
        console.log(state);
        this.props.getRequestsCargo({
            page: state.page,
            limit: state.numberOfRows,
            filters: {
                all: true,
                search: state.search.length !== 0 ? state.search : undefined,
                readinessDate: state.readinessDate.length !== 0 ? state.readinessDate : undefined,
                cancellingDate: state.cancellingDate.length !== 0 ? state.cancellingDate : undefined,
                loadingPort: state.loadingPort.length !== 0 ? state.loadingPort : undefined,
                unloadingPort: state.unloadingPort.length !== 0 ? state.unloadingPort : undefined,
                weightMin: state.weightMin.length !== 0 ? state.weightMin : undefined,
                weightMax: state.weightMax.length !== 0 ? state.weightMax : undefined,
                volumeMin: state.volumeMin.length !== 0 ? state.volumeMin : undefined,
                volumeMax: state.volumeMax.length !== 0 ? state.volumeMax : undefined,
                cargoName: state.cargoName.length !== 0 ? state.cargoName : undefined,
                cargoType: state.cargoType.length !== 0 ? state.cargoType : undefined,
                eh: state.eh,
            },
        });
    }

    UNSAFE_componentWillMount() {
        this.updateRows(this.state);
    }

    UNSAFE_componentWillReceiveProps(props) {
        const cargoTypeNames = props.cargoTypes.map(item => ({
            name: item.name,
            item,
        }));

        this.setState({
            page: props.cargoRequests.page,
            cargoTypeNames,
            filters: {
                ...props.cargoRequests.filters,
                ...this.state.filters,
            },
        });
    }

    handleSearch() {
        this.setState({
            page: 1,
        }, () => {
            this.updateRows(this.state);
        });
    }

    handleEhChange(eh) {
        this.setState({
            ...this.state,
            eh,
        }, () => {
            this.updateRows(this.state);
        });
    }

    render() {
        const {
            search, page,
            loadingPortName, listLoadingPorts,
            unloadingPortName, listUnloadingPorts,
            weightMin, weightMax,
            volumeMax, volumeMin,
            cargoName, cargoNames,
            cargoTypeName, cargoTypeNames,
            readinessDate, cancellingDate,
        } = this.state;

        const cargoRequests = this.props.cargoRequests;
        const cargoRequestsItems = cargoRequests.data;

        if (!cargoRequestsItems) {
            return null;
        }

        return (
            <div>
                <div className='filter'>
                    <div className='filter-row'>
                        <div className='search filter-column' style={{ width: '100%', justifyContent: 'space-between' }}>
                            <TextField
                                value={search}
                                floatingLabelText='Search'
                                onChange={(e, value) => {
                                    this.changeValues('search', value);
                                }}
                            />
                            <EhSelector values={this.state.eh} onChange={this.handleEhChange} />
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <IconButton
                                    iconStyle={styles.navigationLeft}
                                    name='navigationLeft'
                                    onClick={this.prevPage}
                                >
                                    <ChevronLeft />
                                </IconButton>
                                <div className='item'>Page: {this.state.page}</div>
                                <IconButton
                                    iconStyle={styles.navigationRight}
                                    name='navigationRight'
                                    onClick={this.nextPage}
                                >
                                    <ChevronRight />
                                </IconButton>
                            </span>
                            <RaisedButton
                                label='Search'
                                style={{ fontSize: '13px', margin: '0 0 0 10px' }}
                                onClick={this.handleSearch}
                                primary
                            />
                            <RaisedButton
                                label='Clear filters'
                                style={{ fontSize: '13px', margin: '0 0 0 10px' }}
                                onClick={this.handleClearFilters}
                                primary
                            />
                        </div>
                    </div>

                    <div className='filter-row'>
                        <div className='filter-column paper-block'>
                            <div className='name-block absolute small-name'>Dates</div>
                            <DatePicker
                                value={cancellingDate ? toUTC(cancellingDate) : undefined}
                                onChange={(e, date) => { this.changeDate('cancellingDate', date); }}
                                floatingLabelText='cancellingDate'
                                formatDate={date => moment(date).format('MM-DD-YYYY')}
                                style={{ width: '75%' }}
                                textFieldStyle={{ width: '75%' }}
                                autoOk
                            />
                            <DatePicker
                                value={readinessDate ? toUTC(readinessDate) : undefined}                
                                onChange={(e, date) => { this.changeDate('readinessDate', date); }}
                                floatingLabelText='readinessDate'
                                formatDate={date => moment(date).format('MM-DD-YYYY')}
                                style={{ width: '75%' }}
                                textFieldStyle={{ width: '75%' }}
                                autoOk
                            />

                        </div>
                        <div className='filter-column paper-block'>
                            <div className='name-block absolute small-name'>LUports</div>
                            <AutoComplete
                                floatingLabelText='Loading port'
                                searchText={loadingPortName}
                                dataSource={listLoadingPorts}
                                dataSourceConfig={{ text: 'name', value: 'item' }}
                                onUpdateInput={e => this.onChangeAutoComplete(e, 'loading')}
                                onNewRequest={this.onChooseAutoComplete.bind(this, 'loading')}
                                filter={AutoComplete.noFilter}
                                style={{ width: '75%' }}
                                textFieldStyle={{ width: '75%' }}

                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                            />
                            <AutoComplete
                                floatingLabelText='Unloading port'
                                searchText={unloadingPortName}
                                dataSource={listUnloadingPorts}
                                dataSourceConfig={{ text: 'name', value: 'item' }}
                                onUpdateInput={e => this.onChangeAutoComplete(e, 'unloading')}
                                onNewRequest={this.onChooseAutoComplete.bind(this, 'unloading')}
                                filter={AutoComplete.noFilter}
                                style={{ width: '75%' }}
                                textFieldStyle={{ width: '75%' }}

                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                            />
                        </div>
                    </div>

                    <div className='filter-row'>
                        <div className='filter-column paper-block'>
                            <div className='name-block absolute small-name'>Weight</div>

                            <TextField
                                type='number'
                                floatingLabelText='weightMin'
                                value={weightMin}
                                style={{ width: '75%' }}
                                inputStyle={{ width: '75%' }}
                                onChange={(e) => {
                                    this.changeValues('weightMin', e.target.value);
                                }}
                            />
                            <TextField
                                type='number'
                                floatingLabelText='weightMax'
                                value={weightMax}
                                style={{ width: '75%' }}
                                inputStyle={{ width: '75%' }}
                                onChange={(e) => {
                                    this.changeValues('weightMax', e.target.value);
                                }}
                            />
                        </div>
                        <div className='filter-column paper-block'>
                            <div className='name-block absolute small-name'>Volume</div>

                            <TextField
                                type='number'
                                floatingLabelText='volumeMin'
                                value={volumeMin}
                                style={{ width: '75%' }}
                                inputStyle={{ width: '75%' }}
                                onChange={(e) => {
                                    this.changeValues('volumeMin', e.target.value);
                                }}
                            />
                            <TextField
                                type='number'
                                floatingLabelText='volumeMax'
                                value={volumeMax}
                                style={{ width: '75%' }}
                                inputStyle={{ width: '75%' }}
                                onChange={(e) => {
                                    this.changeValues('volumeMax', e.target.value);
                                }}
                            />
                        </div>
                    </div>

                    <div className='filter-row'>
                        <div className='filter-column paper-block'>
                            <div className='name-block absolute small-name'>Cargoes info</div>

                            <AutoComplete
                                floatingLabelText='Cargo names'
                                searchText={cargoName}
                                dataSource={cargoNames}
                                dataSourceConfig={{ text: 'name', value: 'item' }}
                                onUpdateInput={this.onUpdateInputCargoName}
                                onNewRequest={this.onNewRequestCargoName}
                                filter={AutoComplete.caseInsensitiveFilter}
                                style={{ width: '75%' }}
                                textFieldStyle={{ width: '75%' }}
                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                            />
                            <AutoComplete
                                floatingLabelText='Cargo types'
                                searchText={cargoTypeName}
                                dataSource={cargoTypeNames}
                                dataSourceConfig={{ text: 'name', value: 'item' }}
                                onUpdateInput={this.onUpdateInputCargoType}
                                onNewRequest={this.onNewRequestCargoTypes}
                                filter={AutoComplete.caseInsensitiveFilter}
                                style={{ width: '75%' }}
                                textFieldStyle={{ width: '75%' }}
                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                            />
                        </div>
                    </div>

                    <div>
                        <ul className='list-requests'>
                            {
                                cargoRequestsItems.map(item => <CargoRequestsItem key={item._id} item={item} />)
                            }
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        cargoRequests: state.cargoRequests,
        cargoTypes: state.cargoTypes,
    }),
    dispatch => bindActionCreators(
        {
            getRequestsCargo,
        },
        dispatch,
    ),
)(CargoRequestsList);



// WEBPACK FOOTER //
// ./app/components/Cargoes/Requests/List.jsx